/* 
Importing the components and dependencies
*/
import * as service from "./../../../Service/Report.service";
import { FirebaseCollectionName } from "../../../Constants/ReportTypesConstants";
import { toasterModel, toasterColor } from "../../../Models/ToasterModel";

/* 
Logics for the ReportStatusTasks
*/
export default {
  name: "panel",
  props: {
    doucmentId: String,
    reportDetails: Object,
  },
  data() {
    return {
      reportName: "",
      reportStatusTasksId: "",
      snackbar: false,
      snackbarColor: "",
      snackbarText: "",
      rows: [],
      menu: false,
      modal: false,
      menu2: false,
      startdate: "",
      duedate: "",
      total: 0,
      grandtotal: 0,
      taxtotal: 0,
      delivery: 40,
      headers: [
        {
          text: "Description",
          sortable: false,
          value: "description",
          class: "datatable-descriptionheader",
        },
        {
          text: "Start Date",
          value: "startdate",
          sortable: false,
          class: "datatable-startdateheader",
        },
        {
          text: "Due Date",
          value: "duedate",
          sortable: false,
          class: "datatable-duedateheader",
        },
        {
          text: "",
          value: "",
          sortable: false,
          class: "datatable-addremoveheader",
        },
      ],
    };
  },
  mounted() {
    this.rows = JSON.parse(JSON.stringify(this.reportDetails.ToDoList));
    // Extract query string from url and set active status report
  },
  methods: {
    addRow: function(index) {
      try {
        // var ind = this.rows.length;
        this.rows.push({
          description: "",
          startdate: "",
          duedate: "",
        });
      } catch (e) {
        console.log(e);
      }
    },
    removeRow: function(index) {
      this.rows.splice(index, 1);
      var ind = this.rows.length;
      if (ind == 0) {
        this.rows.splice(0, 0, {
          description: "",
          startdate: "",
          duedate: "",
        });
      }
    },

    async saveReportStatusTasks() {
      var emptyDescriptions = this.rows.filter(
        (x) => x.description.trim().length == 0
      );

      if (emptyDescriptions.length > 0) {
        this.$store.commit(
          "toaster",
          toasterModel("Description cannot be empty", "warning")
        );
        return false;
      }
      debugger;

      this.reportDetails.ToDoList = this.rows;

      var result = await service.createorUpdateDocument(
        this.doucmentId,
        FirebaseCollectionName.Reports,
        this.reportDetails
      );
      if (result != null) {
        this.$store.commit(
          "toaster",
          toasterModel("Successfully Saved Strategies")
        );
      }
    },
  },
};
